import HotdogShapeComponent from "./hotdog-shape-component";
import HotdogShapeConfig from "./hotdog-shape-config";
import HotdogShapeAdvancedConfig from "./hotdog-shape-advanced-config";

export default {
  HotdogShapeComponent,
  HotdogShapeConfig,
  HotdogShapeAdvancedConfig
};
